import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { trackEvent } from '../../../helpers/ComponentHelper'
import * as Styled from './video-renderer.styles'

const VideoRenderer = ({ videoId, videoSource, validVideo, ratio, noCookie }) => {
  const [videoLoaded, setVideoLoaded] = useState(false)

  const loadVideo = () => {
    setVideoLoaded(true)
    trackEvent(
      {
        eventInfo: {
          eventName: 'cmsVideoInteraction',
          eventAction: 'cms interaction'
        }
      },
      window
    )
  }

  if (!validVideo) return null
  const VideoContainer = ratio === '3-by-2' ? Styled.ThreeByTwoContainer : Styled.Container
  const PlayerPlaceholder = ratio === '3-by-2' ? Styled.PlayerPlaceholder3by2 : Styled.PlayerPlaceholder
  const playerId = videoSource === 'youtube' && `yt-player--${videoId}`
  const videoParams =
    videoSource === 'youtube' &&
    'autoplay=1&cc_load_policy=1&rel=0&modestbranding=1&showinfo=0&enablejsapi=1&origin=https://argos.co.uk'

  const videoSrc =
    videoSource === 'youtube' && `https://www.youtube${noCookie ? '-nocookie' : ''}.com/embed/${videoId}?${videoParams}`

  const videoPlaceholder = { backgroundImage: `url('https://img.youtube.com/vi/${videoId}/sddefault.jpg')` }
  if (!videoLoaded) {
    return (
      <VideoContainer data-test='video-renderer-container'>
        <PlayerPlaceholder
          data-test='video-renderer-player-wrapper'
          tabIndex='0'
          role='button'
          onClick={() => loadVideo()}
          onKeyPress={() => loadVideo()}
          style={videoPlaceholder}
        >
          <Styled.PlayButton data-test='video-renderer-playButton' />
        </PlayerPlaceholder>
      </VideoContainer>
    )
  }
  return (
    <VideoContainer data-test='video-renderer-container'>
      <Styled.PlayerPlaceholder data-test='video-renderer-player-wrapper'>
        <Styled.IFrame
          data-test='video-renderer-player-iframe'
          title={`play video - ${playerId}`}
          allow='autoplay'
          id={playerId}
          type='text/html'
          src={videoSrc}
          frameBorder='0'
        />
      </Styled.PlayerPlaceholder>
    </VideoContainer>
  )
}

VideoRenderer.defaultProps = {
  noCookie: true,
  videoSource: 'youtube',
  ratio: '16-by-9'
}

VideoRenderer.propTypes = {
  noCookie: PropTypes.bool,
  ratio: PropTypes.string,
  validVideo: PropTypes.bool,
  videoId: PropTypes.string,
  videoSource: PropTypes.oneOf(['youtube', 'amplience'])
}

export default VideoRenderer
